module.exports = __webpack_public_path__ + "static/media/2.67a098d3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/ruined/2.mp3
// module id = 505
// module chunks = 0